import { useCallback } from 'react'
import { useR2StateContext, useR2Highlights } from '../../../providers/r2Provider/R2Context'
import { setDisplayHighlights } from '../../../utils/imageHighlightUtils'

/*
 * Set the record level highlights for one record. This needs to be done every time a panel changes
 * (or at least every time the edit highlights has been opened)
 */
const useSetRecordHighlightsOfOneRecord = () => {
  const { recordEditHighlights, selectedRecordId, referenceRecordHighlights, splitScreen } = useR2StateContext()
  const { recordDisplayHighlightsApi, splitScreenRecordDisplayHighlightsApi } = useR2Highlights()

  return useCallback(() => {
    // display record level highlights
    setDisplayHighlights(
      recordEditHighlights?.filter((highlight) => highlight.id === selectedRecordId),
      recordDisplayHighlightsApi
    )
    if (splitScreen) {
      // display record level highlights on split screen
      setDisplayHighlights(
        referenceRecordHighlights?.filter((highlight) => highlight.id === selectedRecordId),
        splitScreenRecordDisplayHighlightsApi
      )
    }
  }, [
    recordDisplayHighlightsApi,
    recordEditHighlights,
    referenceRecordHighlights,
    selectedRecordId,
    splitScreen,
    splitScreenRecordDisplayHighlightsApi,
  ])
}

export default useSetRecordHighlightsOfOneRecord
